export function initializeMobileFormExpander() {
  const contactForm = document.body.querySelector('.mobile-form-expand-test');
  let isButtonFixed = false;
  if (!contactForm) {
    return;
  }

  const expandButtons = contactForm.querySelectorAll('.expand-mobile-button button');
  for (const expandButton of expandButtons) {
    expandButton.addEventListener('click', toggleForm);
  }

  const fixedButton = contactForm.querySelector('.expand-mobile-button.fixed');

  const expandButtonWrap = contactForm.querySelector('.expand-mobile-button-wrap');

  const closeButtons = contactForm.querySelectorAll('.stepper-form-close');
  for (const closeButton of closeButtons) {
    closeButton.addEventListener('click', toggleForm);
  }


  window.addEventListener('scroll', () => {
    if (expandButtonWrap.getBoundingClientRect().top < 0 && !isButtonFixed) {
      fixedButton.classList.add('visible');
      isButtonFixed = true;
    } else if (expandButtonWrap.getBoundingClientRect().top > 0 && isButtonFixed) {
      fixedButton.classList.remove('visible');
      isButtonFixed = false;
    }
  });
}

function toggleForm() {
  const isExpanded = document.body.classList.contains('mobile-form-expanded')
  if (window.dataLayer && !isExpanded) {
    dataLayer.push({
      'event':'contact_form_mobile',
      'action':'open',
      'label':'Interested in a partnership?',
      'category': undefined,
      'component':'contact-form-mobile',
      'position': undefined,
      'language': window.pageLanguage || 'en',
      '_clear': true
    });
  }

  document.body.classList.toggle('mobile-form-expanded');
}
